export default __webpack_public_path__ + "img/b32c33f72c9354fb799163f2204e8d4e.svg";